import { List, Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { Fragment, memo, useMemo } from 'react';

// @ts-expect-error - Remove once type definitions are available
import { getType } from '../../../common-message-format/operators/commonMessageFormatGetters';
import { TYPICAL_RESPONSE_TIME } from '../../../typical-response-time/constants/messageTypes';
// @ts-expect-error - Remove once type definitions are available
import { areMessagesGrouped } from '../../../message-history/operators/areMessagesGrouped';
// @ts-expect-error - Remove once type definitions are available
import { getAttachmentsForMessage } from '../../../message-history/operators/getAttachmentsForMessage';
// @ts-expect-error - Remove once type definitions are available
import { getMessageId } from '../../../message-history/operators/getMessageId';
// @ts-expect-error - Remove once type definitions are available
import { getPositionDescriptors } from '../../../message-history/operators/getPositionDescriptors';
// @ts-expect-error - Remove once type definitions are available
import MessageHistoryItem from './MessageHistoryItem';
import { getHiddenBy } from '../../../common-message-format/operators/commonMessageGetters';
import { CustomerAgentCTATile } from './CustomerAgentCTATile';
import { getSampleMessageId } from '../utils/customerAgentCTAUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MessageHistoryCoreBaseComponent({
  allowContactPromotions,
  channelName,
  disableCustomerAgentCTA = false,
  fileAttachments = ImmutableMap(),
  friendlyNames,
  getAdditionalPositionDescriptors = () => ImmutableMap(),
  historyConfig,
  indexedAsyncFileAttachments,
  isUngatedForCustomerAgentDiscoverability = false,
  lastMessageId,
  legacyRecipients,
  messages,
  portalId,
  presentSenderLocators = ImmutableSet(),
  senders,
  slots,
  threadId,
  ungatedForChatspot = false,
  ungatedForNewForkedComponent,
  ungatedForOmnichannelCallSummaryAiSkill = false,
  ungatedForUnifiedCallSummary = false,
  vid,
  visitorLastReadTimestamp,
  visitorRecipients
}) {
  const getDontIncludeLastInGroup = (message, index) => {
    const nextNextMessage = messages === null || messages === void 0 ? void 0 : messages.get(index + 2);
    if (nextNextMessage && areMessagesGrouped(message, nextNextMessage)) {
      return true;
    }
    return false;
  };
  const additionalPositionDescriptors = getAdditionalPositionDescriptors(messages || List()) || ImmutableMap();
  const messagesArray = useMemo(() => (messages === null || messages === void 0 ? void 0 : messages.toArray()) || [], [messages]);
  const messageIdToShowCTA = useMemo(() => disableCustomerAgentCTA ? null : getSampleMessageId(messagesArray, isUngatedForCustomerAgentDiscoverability), [messagesArray, isUngatedForCustomerAgentDiscoverability, disableCustomerAgentCTA]);
  return messages === null || messages === void 0 ? void 0 : messages.map((message, index) => {
    const previousMessage = index > 0 ? messages.get(index - 1) : undefined;
    const nextMessage = messages.get(index + 1);
    let dontIncludeLastInGroup;
    if (getType(nextMessage) === TYPICAL_RESPONSE_TIME) {
      dontIncludeLastInGroup = getDontIncludeLastInGroup(message, index);
    }
    const fileAttachmentsForMessage = getAttachmentsForMessage(message, fileAttachments);
    let positionDescriptors = getPositionDescriptors(message, previousMessage, nextMessage, dontIncludeLastInGroup);
    const messageId = getMessageId(message);
    const hiddenBy = getHiddenBy(message);
    positionDescriptors = positionDescriptors.merge(additionalPositionDescriptors.get(messageId, ImmutableSet()));
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [messageIdToShowCTA === messageId && /*#__PURE__*/_jsx(CustomerAgentCTATile, {}), /*#__PURE__*/_jsx(MessageHistoryItem, {
        allowContactPromotions: allowContactPromotions,
        hiddenBy: hiddenBy,
        historyConfig: historyConfig,
        fileAttachments: fileAttachmentsForMessage,
        fileAttachmentsForThread: fileAttachments,
        friendlyNames: friendlyNames,
        indexedAsyncFileAttachments: indexedAsyncFileAttachments,
        portalId: portalId,
        positionDescriptors: positionDescriptors,
        message: message,
        senders: senders,
        presentSenderLocators: presentSenderLocators,
        visitorLastReadTimestamp: visitorLastReadTimestamp,
        lastMessageId: lastMessageId,
        vid: vid,
        visitorRecipients: visitorRecipients,
        ungatedForChatspot: ungatedForChatspot,
        ungatedForNewForkedComponent: ungatedForNewForkedComponent,
        ungatedForOmnichannelCallSummaryAiSkill: ungatedForOmnichannelCallSummaryAiSkill,
        ungatedForUnifiedCallSummary: ungatedForUnifiedCallSummary,
        threadId: threadId,
        legacyRecipients: legacyRecipients,
        channelName: channelName,
        slots: slots
      })]
    }, messageId);
  });
}
MessageHistoryCoreBaseComponent.displayName = 'MessageHistoryCoreBase';
const MessageHistoryCoreBase = /*#__PURE__*/memo(MessageHistoryCoreBaseComponent);
export default MessageHistoryCoreBase;